(function() {
    document.addEventListener('click', function(e) {
        var target = e.target;
        // if the target has the attribute data-clipboard or is a child of an element with the attribute data-clipboard
        if(target.hasAttribute('data-clipboard') || target.closest('[data-clipboard]')) {
            // get the element with the attribute data-clipboard
            target = target.closest('[data-clipboard]');
            copyToClipboard(target);
        }
    });    
}());

function copyToClipboard(item) {
    var msgToCopy = item.dataset.clipboard;
    var msgToCopyOriginal = msgToCopy;
    // check if item has the attribute data-clipboard-uri-decode
    if(item.hasAttribute('data-clipboard-uri-decode')) {
        // decode the uri
        msgToCopy = decodeURIComponent(msgToCopy);
    }
    
    if(msgToCopy) {
        try {
            navigator.clipboard.writeText(msgToCopy);

            // get the tooltip (data-clipboard-confirm) with the same value as the data-clipboard attribute
            var tooltip = document.querySelector('[data-clipboard-confirm="' + msgToCopyOriginal + '"]');
            if(tooltip) {
                tooltip.classList.add('js-opacity-animation');
                // set css variable --u-opacity-animation to 1
                tooltip.style.setProperty('--u-opacity-animation', 1);
                setTimeout(function() {
                    tooltip.style.setProperty('--u-opacity-animation', 0);
                    tooltip.classList.remove('js-opacity-animation');
                }, 2000);
            }

        } catch (err) {
            console.log('Oops, unable to copy', err);
        }
    }
}